import { InputField, TextAreaField } from 'lib/iterable-hook-form';
import { BasicSelectField } from 'lib/iterable-hook-form/FormField';
import { AUTH_TYPE, AUTH_TYPE_DROPDOWN_OPTIONS } from 'modules/campaigns/alerts/constants';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';
import { DestinationsFormValues } from '../context';
import { WebhookAuthType, WebhookFormField } from '../types';

export const BASE_WEBHOOK_TEST_ID = 'campaign-alerts-webhook';

const StyledBasicSelectField = styled(BasicSelectField)`
  width: ${spacing.x12};
`;

export const AddOrEditForm = () => {
  const {
    watch,
    formState: { errors },
  } = useFormContext<DestinationsFormValues>();
  const authType = watch(WebhookFormField.AuthType);

  const basicAuthErrors = WebhookFormField.AuthToken in errors ? errors : {};
  const oauth2AuthErrors =
    WebhookFormField.ClientId in errors ||
    WebhookFormField.ClientSecret in errors ||
    WebhookFormField.TokenEndpoint in errors
      ? errors
      : {};

  const nameErrorMessage = errors?.name?.message;
  const endpointErrorMessage = errors?.endpoint?.message;
  const authTypeErrorMessage = errors?.authType?.message;

  const authTokenErrorMessage = basicAuthErrors?.authToken?.message;

  const clientIdErrorMessage = oauth2AuthErrors?.clientId?.message;
  const clientSecretErrorMessage = oauth2AuthErrors?.clientSecret?.message;
  const tokenEndpointErrorMessage = oauth2AuthErrors?.tokenEndpoint?.message;

  return (
    <>
      <FormField
        labelText="Webhook name"
        hasError={!!nameErrorMessage}
        errorText={nameErrorMessage}
        data-test={`${BASE_WEBHOOK_TEST_ID}-name`}
      >
        <TextAreaField
          name={WebhookFormField.Name}
          placeholder="My webhook"
          autoGrowMinHeight={1}
          rows={1}
          hasWrapperStyling={false}
          autoFocus
        />
      </FormField>
      <FormField
        labelText="Endpoint URL"
        hasError={!!endpointErrorMessage}
        errorText={endpointErrorMessage}
        data-test={`${BASE_WEBHOOK_TEST_ID}-endpoint`}
      >
        <InputField
          name={WebhookFormField.Endpoint}
          placeholder="https://yourwebsiteurl.com/webhook"
        />
      </FormField>
      <FormField
        labelText="Authentication"
        hasError={!!authTypeErrorMessage}
        errorText={authTypeErrorMessage}
        data-test={`${BASE_WEBHOOK_TEST_ID}-authType`}
      >
        <StyledBasicSelectField
          name={WebhookFormField.AuthType}
          options={AUTH_TYPE_DROPDOWN_OPTIONS}
          defaultValue={AUTH_TYPE.NONE}
        />
      </FormField>
      {authType === WebhookAuthType.BASIC && (
        <FormField
          labelText="Authentication token"
          hasError={!!authTokenErrorMessage}
          errorText={authTokenErrorMessage}
          data-test={`${BASE_WEBHOOK_TEST_ID}-authToken`}
        >
          <InputField name={WebhookFormField.AuthToken} />
        </FormField>
      )}
      {authType === WebhookAuthType.OAUTH2 && (
        <>
          <FormField
            labelText="Client ID"
            hasError={!!clientIdErrorMessage}
            errorText={clientIdErrorMessage}
            data-test={`${BASE_WEBHOOK_TEST_ID}-clientId`}
          >
            <InputField name={WebhookFormField.ClientId} />
          </FormField>
          <FormField
            labelText="Client secret"
            hasError={!!clientSecretErrorMessage}
            errorText={clientSecretErrorMessage}
            data-test={`${BASE_WEBHOOK_TEST_ID}-clientSecret`}
          >
            <InputField name={WebhookFormField.ClientSecret} />
          </FormField>
          <FormField
            labelText="Token URL"
            hasError={!!tokenEndpointErrorMessage}
            errorText={tokenEndpointErrorMessage}
            data-test={`${BASE_WEBHOOK_TEST_ID}-tokenEndpoint`}
          >
            <InputField name={WebhookFormField.TokenEndpoint} />
          </FormField>
        </>
      )}
    </>
  );
};
